module.exports = __webpack_public_path__ + "img/conny-f-stage1-blink.ad10971a.png";